var map = {
	"./arvest_big.svg": 8250,
	"./arvest_small.svg": 6554,
	"./bancorp_big.svg": 4899,
	"./bancorp_small.svg": 4764,
	"./bank_of_am_big.svg": 5628,
	"./bank_of_am_small.svg": 8153,
	"./barclays_big.svg": 6198,
	"./barclays_small.svg": 8983,
	"./bmo_bank_big.svg": 2549,
	"./bmo_bank_small.svg": 7743,
	"./bny_mellon_big.svg": 7274,
	"./bny_mellon_small.svg": 1023,
	"./capital_one_big.svg": 9479,
	"./capital_one_small.svg": 1295,
	"./cathay_big.svg": 9609,
	"./cathay_small.svg": 6140,
	"./cibc_big.svg": 9119,
	"./cibc_small.svg": 9096,
	"./citi_bank_big.svg": 1075,
	"./citi_bank_small.svg": 1656,
	"./comerica_big.svg": 9243,
	"./comerica_small.svg": 8787,
	"./deutsche_big.svg": 4388,
	"./deutsche_small.svg": 7234,
	"./federal_home_big.svg": 8164,
	"./federal_home_small.svg": 4747,
	"./federal_reserve_big.svg": 3532,
	"./federal_reserve_small.svg": 3725,
	"./fiduciary_big.svg": 728,
	"./fiduciary_small.svg": 4879,
	"./fifth_third_big.svg": 5753,
	"./fifth_third_small.svg": 4523,
	"./hsbc_bank_big.svg": 1743,
	"./hsbc_bank_small.svg": 1841,
	"./huntington_bank_big.svg": 5336,
	"./huntington_bank_small.svg": 9652,
	"./jp_morgam_big.svg": 4019,
	"./jp_morgam_small.svg": 5526,
	"./key_bank_big.svg": 84,
	"./key_bank_small.svg": 4588,
	"./one_united_big.svg": 1458,
	"./one_united_small.svg": 5649,
	"./pnc_bank_big.svg": 7135,
	"./pnc_bank_small.svg": 2975,
	"./regions_bank_big.svg": 7937,
	"./regions_bank_small.svg": 1129,
	"./santander_big.svg": 8005,
	"./santander_small.svg": 2,
	"./state_street_big.svg": 4433,
	"./state_street_small.svg": 5774,
	"./synovus_big.svg": 410,
	"./synovus_small.svg": 9341,
	"./td_bank_big.svg": 3396,
	"./td_bank_small.svg": 3625,
	"./truist_bank_big.svg": 2084,
	"./truist_bank_small.svg": 1237,
	"./wells_fargo_big.svg": 9579,
	"./wells_fargo_small.svg": 5775,
	"./woodforest_bank_big.svg": 2461,
	"./woodforest_bank_small.svg": 6949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7501;